import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-cards.css';

var getClassNameList = classNames.bind(styles);
var UitkCardActionArea = function (props) {
    var className = props.className, children = props.children, attributes = __rest(props, ["className", "children"]);
    var baseClass = 'uitk-card-action-area';
    var cssClassNames = getClassNameList(baseClass, className);
    return (React.createElement("div", __assign({ className: cssClassNames }, attributes), children));
};
UitkCardActionArea.displayName = 'UitkCardActionArea';
// Temporary, unstable
var UitkCardAlohaActionArea = UitkCardActionArea;

export { UitkCardActionArea, UitkCardAlohaActionArea };
